/**
 * Collection credit hold recommendation API permissions (design §13.1).
 */

export const COLLECTION_CREDIT_HOLD_READ_PERMISSION = 'collection_credit_hold:read' as const;
export const COLLECTION_CREDIT_HOLD_DISMISS_PERMISSION = 'collection_credit_hold:dismiss' as const;
export const COLLECTION_CREDIT_HOLD_DEFER_PERMISSION = 'collection_credit_hold:defer' as const;
export const COLLECTION_CREDIT_HOLD_ESCALATE_PERMISSION =
  'collection_credit_hold:escalate' as const;
export const COLLECTION_CREDIT_HOLD_EVALUATE_PERMISSION =
  'collection_credit_hold:evaluate' as const;

/** Bounded V1 read fallback for operators with AR collection surface access. */
export const COLLECTION_CREDIT_HOLD_READ_FALLBACK_PERMISSION = 'ar_collection:read' as const;

export const COLLECTION_CREDIT_HOLD_PERMISSIONS = [
  COLLECTION_CREDIT_HOLD_READ_PERMISSION,
  COLLECTION_CREDIT_HOLD_DISMISS_PERMISSION,
  COLLECTION_CREDIT_HOLD_DEFER_PERMISSION,
  COLLECTION_CREDIT_HOLD_ESCALATE_PERMISSION,
  COLLECTION_CREDIT_HOLD_EVALUATE_PERMISSION,
] as const;

export type CollectionCreditHoldPermission = (typeof COLLECTION_CREDIT_HOLD_PERMISSIONS)[number];

export function isCollectionCreditHoldPermission(
  permission: string
): permission is CollectionCreditHoldPermission {
  return (COLLECTION_CREDIT_HOLD_PERMISSIONS as readonly string[]).includes(permission);
}
